import React from "react"
import { useStaticQuery, graphql } from 'gatsby'
import { Link } from "gatsby"

import Layout from '../components/layout'
import '../styles/index.scss'
import '../styles/contactbutton.scss'
import '../styles/button.scss'
import headerStyles from '../styles/header.module.scss'
import contactoStyles from '../styles/contacto.module.scss'
import Metatags from '../components/metatag';
import { css } from "@emotion/core"


// Calendly
import Calendly from '../components/calendly';

// Iconos
import { MdEmail } from "react-icons/md"
import { IoIosArrowRoundDown } from "react-icons/io";

// Background
import BackgroundPoint from "../../static/background-point.svg"

import socialCard from '../images/card.jpg'


const Contact = () => {

    const data = useStaticQuery(graphql`
        query{
            site{
                siteMetadata{
                    title
                    description
                    siteUrl
                }
            }
        }
    
    `)

    return(

        <Layout>
            <Metatags
                title={`${data.site.siteMetadata.title} | Contacto`}
                description={data.site.siteMetadata.description}
                thumbnail={`${data.site.siteMetadata.siteUrl}${socialCard}`}
                url= {data.site.siteMetadata.siteUrl}
            />
            <section className={headerStyles.header_wrapper}>

                <div className={headerStyles.header_wrapper_mid}>
                    <h3 className={headerStyles.header_wrapper_title} css={css`text-align: center;`}>Contacto</h3>
                    <h1 className={headerStyles.header_wrapper_main}><span className={headerStyles.header_wrapper_main_highlight}>Contáctame</span>, empecemos a trabajar juntos. 
                    </h1>
                    <p className={headerStyles.header_wrapper_text} css={css`width: 100%`}>Ponte en contacto conmigo para cualquier pregunta, solicitar presupuesto o comenzar tu proyecto.</p>
                    <Link to='/contacto/#contacta' className="btn btn__white btn__animated">Contáctame</Link>

                </div>
            </section>
            <IoIosArrowRoundDown className={headerStyles.header_arrow} />
            <section className={contactoStyles.contacta} id="contacta">
                <div className={contactoStyles.contacta_wrapper}>
                     <div className={contactoStyles.contacta_wrapper_left}>

                        <h2 className={headerStyles.header_titles_text}><span className={headerStyles.header_titles_text_point}>¡</span>Hablemos<span className={headerStyles.header_titles_text_point}>!</span></h2>

                        <p>Trato cada <strong>proyecto como único</strong>. Para poder ofrecerte el <strong>mejor presupuesto</strong> para tu proyecto, por favor rellena el formulario y cuéntame sobre el, qué es lo que necesitas y cuál es el objetivo que te marcas.
                        Si lo prefieres, puedes ponerte en contacto conmigo a través de mi <a href="mailto:felixdigitalco@gmail.com" css={css`
                        text-decoration: 
                        underline; cursor: pointer;
                        color: #000;
                        
                        :hover{
                            color: #A58861;
                        }

                        `}><span id="main" ><strong>email</strong></span></a> o <span id="agendar"></span><Link to="/contacto/#schedule_form"><span css={css`
                        text-decoration: 
                        underline; cursor: pointer;
                        color: #000;
                        
                        :hover{
                            color: #A58861;
                        }

                        `}><strong>agendar una llamada conmigo</strong></span></Link>.</p>

                        <form name="contactame" method="POST" data-netlify="true" data-netlify-honeypot="bot-field" className={contactoStyles.contacta_wrapper_left_formulario}>

                            <input type="hidden" name="form-name" value="contactame" />

                            <div className={contactoStyles.contacta_wrapper_left_formulario_select}>
                                <label className={contactoStyles.label}>¿Qué servicio necesitas? <select className={contactoStyles.contacta_wrapper_left_formulario_select_field} name="servicio[]">
                                        <option value="web">Página Web</option>
                                        <option value="tiendaonline">Tienda online</option>
                                        <option value="landingpage">Landing Page</option>
                                        <option value="presupuesto">Presupuesto sin compromiso para mi proyecto</option>
                                        <option value="pregunta">Responder a una pregunta</option>
                                    </select>
                                </label>
                            </div>

                            <label className={contactoStyles.label}>Nombre y Apellidos*
                                <input className={contactoStyles.contacta_wrapper_left_formulario_style} name="nombre" type="text" required/>
                            </label>

                            <label className={contactoStyles.label}>Email*
                                <input className={contactoStyles.contacta_wrapper_left_formulario_style} name="email" type="email" required/>
                            </label>

                            <label className={contactoStyles.label}>Teléfono*
                                <input className={contactoStyles.contacta_wrapper_left_formulario_style} name="telefono" type="tel" required/>
                            </label>

                            <label className={contactoStyles.label}>Página web <span css={css`font-size:0.8rem;`}>(Opcional)</span>
                                <input className={contactoStyles.contacta_wrapper_left_formulario_style} name="paginaweb" type="text" placeholder="Sólo si tienes actualmente una web"/>
                            </label>

                            <label className={contactoStyles.label}>Mensaje
                                <textarea className={contactoStyles.contacta_wrapper_left_formulario_textarea} name="message" placeholder="Cuéntame un poco sobre tu proyecto..." required />
                            </label>

                            <button className={contactoStyles.btn_small_gold} type="submit" css={css`padding-top: 19px; padding-bottom: 19px;`}>
                                Enviar
                            </button>

                        </form>
                    
                </div>
                <div className={contactoStyles.contacta_wrapper_right}>
                    <div css={css`
                                        position: absolute;
                                        width: 70%;
                                        height: 30%;
                                        right: -2%;
                                        top: 4%;                              
                                        display: block;
                                        background-image: url(${BackgroundPoint});
                                        background-size: 10px;
                                        background-repeat: repeat;
                                        z-index: 8;
                                        
                        `}></div>
                    <div className={contactoStyles.contacta_wrapper_right_mail} id="mail">
                        <h3><span css={css`font-weight: 400`}>¿</span>Alguna pregunta<span css={css`font-weight: 400`}>?</span></h3>
                        <h4 css={css`color: #fff; font-size: 1.5rem; margin: 0;`}><span css={css`font-weight: 400`}>¡Envíame un email!</span></h4> 
                        <p>Si tienes alguna duda o necesitas más información, puedes contactarme a <strong>felixdigitalco@gmail.com</strong></p>
                        <a href="mailto:felixdigitalco@gmail.com" className="btn_small btn_small__gold"><MdEmail css={css`vertical-align: text-bottom; width: 1.2em; height: 1.2em;`}/> Enviar email</a>

                        
                    </div>
                    <Calendly account="felixdigital" eventName="asesoramiento-gratis"/>
                    
                </div>

                </div>

               
            </section>
            

           
            
        </Layout>
    )


}

export default Contact